import type { IconData } from '@stacksjs/iconify-core'

export const noSmakingAreaSolid: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M6.121 1.879A3 3 0 1 0 1.88 6.12l40 40a3 3 0 1 0 4.242-4.242L34.613 30.37c-.064-1.62-.113-3.727-.113-6.37c0-3.693.096-6.34.193-8.072l.02-.356a827 827 0 0 0-14.96-.061zm1.456 13.819l-.146.004c-2.686.08-5.35 1.762-5.73 4.82c-.12.964-.201 2.119-.201 3.478c0 1.36.081 2.514.2 3.477c.381 3.059 3.045 4.741 5.731 4.82c3.167.094 8.566.203 16.569.203h.379z\"/><path fill=\"currentColor\" d=\"M37.716 15.622q2.042.041 3.518.082c2.961.081 5.266 2.508 5.266 5.442v5.709c0 2.933-2.305 5.36-5.266 5.44q-1.476.042-3.518.083q-.015-.224-.028-.474C37.595 30.232 37.5 27.64 37.5 24c0-3.641.095-6.232.188-7.904z\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default noSmakingAreaSolid
